export default __webpack_public_path__ + "static/media/LHB-WHT.02225036.png";